import {
  Button,
  CustomTooltip as Tooltip,
} from '@fountain/fountain-ui-components';
import { iconVariants, XCircleOutlineIcon } from '@fountain/ripple/icon';
import { IconButton } from '@material-ui/core';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { MoveToNextStageIcon } from 'components/KeptIcons';
import messages from 'shared/global/messages';
import theme from 'theme';

import { useStyles } from './styles';

const APPLICANT_TABLE_QUICK_ACTIONS_ICON_CLASSNAME =
  'applicant-table-quick-actions-icon';

interface ActionsProps {
  handleClickNextStage: () => void;
  handleClickReject: () => void;
  disabled?: boolean;
}

const QuickActionsIconButton: FC<ActionsProps> = ({
  handleClickNextStage,
  handleClickReject,
  disabled,
}) => {
  const intl = useIntl();
  return (
    <>
      <Tooltip dense title={<FormattedMessage {...messages.moveToNextStage} />}>
        <IconButton
          aria-label={intl.formatMessage(messages.moveToNextStage)}
          className={APPLICANT_TABLE_QUICK_ACTIONS_ICON_CLASSNAME}
          onClick={handleClickNextStage}
          disabled={disabled}
        >
          <MoveToNextStageIcon
            style={{ color: theme.palette.common.gray800 }}
            aria-hidden="true"
            className={iconVariants({ size: 'sm' })}
          />
        </IconButton>
      </Tooltip>
      <Tooltip dense title={<FormattedMessage {...messages.reject} />}>
        <IconButton
          aria-label={intl.formatMessage(messages.reject)}
          className={APPLICANT_TABLE_QUICK_ACTIONS_ICON_CLASSNAME}
          onClick={handleClickReject}
          disabled={disabled}
        >
          <XCircleOutlineIcon
            style={{ color: theme.palette.common.gray800 }}
            aria-hidden="true"
            className={iconVariants({ size: 'sm' })}
          />
        </IconButton>
      </Tooltip>
    </>
  );
};

const QuickActionsTextButton: FC<ActionsProps> = ({
  handleClickNextStage,
  handleClickReject,
  disabled,
}) => {
  const styles = useStyles();
  return (
    <>
      <Tooltip dense title={<FormattedMessage {...messages.moveToNextStage} />}>
        <Button
          className={styles.moveToButton}
          onClick={handleClickNextStage}
          disabled={disabled}
          autoWidth
        >
          <FormattedMessage {...messages.moveToNextStage} />
        </Button>
      </Tooltip>
      <Button
        className={styles.rejectButton}
        type="secondary"
        onClick={handleClickReject}
        disabled={disabled}
      >
        <FormattedMessage {...messages.reject} />
      </Button>
    </>
  );
};

export interface QuickActionsProps extends ActionsProps {
  variant?: 'icon' | 'text';
}

export const QuickActions: FC<QuickActionsProps> = ({ variant, ...props }) => {
  switch (variant) {
    case 'text':
      return <QuickActionsTextButton {...props} />;
    case 'icon':
    default:
      return <QuickActionsIconButton {...props} />;
  }
};
